module.exports = __webpack_public_path__ + "img/586-42dfb3.png";